import '../DeckNav.css';
import DeckNav from '../DeckNav';
import HeaderNav from '../../Components/Header/Header_Nav/Header_Nav';
//one folder up so use ../
//if two folders away use ../../
import SPLoader from '../../Components/Spinner/SpinnerLoader';
import ResourceBar from '../../Components/Resource/ResourceBar';
import { TimeDeckFace } from '../../DeckCardOverviews/BasicWords/TimeOv';
import Footer from '../../Components/Footer/Footer';

export default function TimeNav() {
  return (
<div>
  <SPLoader time={0.6}/>
  <HeaderNav GoBack_to={"/BasicWordsNav"}/>
  <h1 className="DeckTitle-nav">Time (시간)</h1>
  <ResourceBar DeeperLook_to="/TimeDLook" Dictionary_to="/TimeDictionary"/>
  <h1 className="Header2-nav">Flashcards</h1>
  <div><DeckNav faceCard={TimeDeckFace} title_input=""/> </div>
  <Footer/>
</div>
  )
}